import React, { Component } from 'react'
import {
    Text,
    View,
    TouchableOpacity,
    ScrollView,
    Image,
    Animated,
    ActivityIndicator
} from 'react-native'
// import moment from 'moment'

import styles from './styles'

import CONSTANTS from '../../constants/constants'
import {
    indTransFormat,
    groupedTransFormat,
    currencyFormat,
    dateRangeFormat,
    returnValueOrZero
} from '../../lib/index'

import Accordion from '../accordion/index'
import Charts from '../charts/index'

export default class Financials extends Component {
    static NAME = 'Financials'

    constructor(props) {
        super(props)

        this.state = {
            point: null,
            flip: new Animated.Value(0)
        }
    }

    flipCard(){
        Animated.spring(
            this.state.flip,
            {
                toValue: (90 <= this.state.flip._value) ? 0 : 180,
                friction: 8,
                tension: 10
             }
        ).start()
    }

    render() {
        const {
            isLoading,
            title,
            data,
            primaryColor,
            selectedColor,
            layout,
            transactions,
            offsetKeyDate,
            onClose
        } = this.props

        return (
            <View style={styles.container}>
                <Animated.View style={[
                    {
                        width: layout.width,
                        height: layout.height,
                        transform: [
                            {
                                rotateY: this.state.flip.interpolate({
                                    inputRange: [0, 180],
                                    outputRange: ['0deg', '180deg'],
                                })
                            }
                        ]
                    },
                    styles.card
                ]}>
                    <View style={[styles.header, { flex: 3 }]}>
                        <View style={{
                            flex: 8,
                            flexDirection: 'column',
                            justifyContent: 'flex-start'
                        }} >
                            <View style={{ flex: 2, justifyContent: 'flex-end', alignItems: 'flex-start', paddingBottom: 5 }}>
                                <Text style={styles.headerText}>
                                    {title}
                                </Text>
                            </View>
                            <View style={{ flex: 2, justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                                <Text style={styles.headerPeriodText}>
                                    {offsetKeyDate && dateRangeFormat(offsetKeyDate)}
                                </Text>
                            </View>
                            <View style={{ flex: 2, justifyContent: 'flex-end', alignItems: 'flex-start', paddingBottom: 5 }}>
                                {!isLoading && <Text style={styles.headerMoney}>
                                    {currencyFormat(data.sum[title])}
                                </Text>}
                            </View>
                            <View style={{ flex: 3, justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                                {('Revenue' === title) && !isLoading && <Text style={[styles.subHeaderText, { marginBottom: 6 }]}>
                                    from {transactions.length} purchases
                                </Text>}
                                {/*('Investment' === title) && offsetKeyDate && offsetKeyDate.inCycle && !isLoading &&
                                    <Text style={[styles.subHeaderText, { marginBottom: 6 }]}>
                                        your bill is due in {moment().endOf('month').diff(moment().today, 'days')} days
                                </Text>*/}
                                {('Investment' === title) && offsetKeyDate && offsetKeyDate.inCycle && !isLoading &&
                                    <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                        <Image style={{ width: 18, height: 18, marginRight: 8 }}
                                            source={require('../../images/pending.png')} />
                                        <Text style={styles.subHeaderText}>
                                            Auto-Payment Pending
                                        </Text>
                                </View>}
                            </View>
                        </View>
                        <View style={{ flex: 1, justifyContent: 'flex-start', alignItems: 'flex-end' }}>
                            <TouchableOpacity
                                activeOpacity={0.8}
                                onPress={onClose.bind(this)}>
                                    <Image style={{width: 30, height: 30}}
                                        source={require('../../images/close_gray.png')} />
                            </TouchableOpacity>
                        </View>
                    </View>

                    <View style={{ flex: 4, justifyContent:'flex-end', alignSelf: 'stretch' }}>
                        {this.state.point && <View style={{ alignItems: 'center'}}>
                            <Text style={styles.subHeaderText}>
                                {currencyFormat(this.state.point.y)} on {groupedTransFormat(this.state.point.x)}
                            </Text>
                        </View>}

                        {isLoading && <ActivityIndicator size={'large'} color={'#FF009B'} />}

                        {!isLoading && <Charts
                            data={data.aggregation[title]}
                            offsetKeyDate={offsetKeyDate}
                            layout={{ width: layout.width, height: ~~(0.35 * layout.height) }}
                            onPointClick={(point) => { this.setState({ point })}}
                            primaryColor={primaryColor}
                            selectedColor={selectedColor}
                            style={{ alignSelf: 'flex-start' }}
                            noAxisLabels
                            noSelectBox />}
                    </View>

                    <View style={{ flex: 1, justifyContent: 'flex-end' }}>
                        <TouchableOpacity
                            activeOpacity={0.8}
                            onPress={() => this.flipCard()}>
                                <Text style={styles.flipLink}>
                                    VIEW DETAILS
                                </Text>
                        </TouchableOpacity>
                    </View>
                </Animated.View>

                <Animated.View style={[
                    {
                        width: layout.width,
                        height: layout.height,
                        opacity: this.state.flip.interpolate({
                            inputRange: [89, 90],
                            outputRange: [0, 1]
                        }),
                        transform: [
                            {
                                rotateY: this.state.flip.interpolate({
                                    inputRange: [0, 180],
                                    outputRange: ['180deg', '360deg']
                                })
                            }
                        ]
                    },
                    styles.card
                ]}>
                    <View style={[styles.header, { flex: 1 }]}>
                        <View style={{
                            flex: 8,
                            flexDirection: 'column',
                            justifyContent: 'flex-start'
                        }} >
                            <View style={{ flex: 2, justifyContent: 'flex-end', alignItems: 'flex-start', paddingBottom: 5 }}>
                                <Text style={styles.headerText}>
                                    {title} Details
                                </Text>
                            </View>
                            <View style={{ flex: 1, justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                                {!isLoading && <Text style={styles.subHeaderText}>
                                    {transactions.length} transactions for {currencyFormat(data.sum[title])}
                                </Text>}
                            </View>
                        </View>
                        <View style={{ flex: 1, justifyContent: 'flex-start', alignItems: 'flex-end' }}>
                            <TouchableOpacity
                                activeOpacity={0.8}
                                onPress={onClose.bind(this)}>
                                    <Image style={{width: 30, height: 30}}
                                        source={require('../../images/close_gray.png')} />
                            </TouchableOpacity>
                        </View>
                    </View>

                    <View style={{ flex: 6, justifyContent:'flex-end', alignSelf: 'stretch' }}>
                        <ScrollView
                            horizontal={false}>

                            {isLoading && <ActivityIndicator size={'large'} color={'#FF009B'} />}

                            {!isLoading && <Accordion
                                sections={transactions}
                                renderHeader={(section, key, active) => {
                                    let context_date = !section.transaction_context.transaction_date
                                                        ? section.pub_date
                                                        : section.transaction_context.transaction_date

                                    let invest = 0;
                                    if (section.hasOwnProperty('cashback_value')) {
                                        invest = section.cashback_value
                                    } else if (section.hasOwnProperty('refund')) {
                                        invest = section.refund
                                    }

                                    return(
                                        <View key style={[
                                            styles.accHeaderContent,
                                            active && styles.accHeaderContentActive,
                                            key && styles.accHeaderLine
                                        ]}>
                                            <View style={styles.accHeaderType}>
                                                {'new' === section.transaction_kind.toLowerCase()
                                                    ? <Image style={{ width: 32, height: 32 }}
                                                        source={require('../../images/customer_new.png')} />
                                                    : <Image style={{ width: 32, height: 32 }}
                                                        source={require('../../images/customer_returning.png')} />}
                                            </View>
                                            <View style={styles.accHeaderMain}>
                                                <View style={styles.accHeaderMainView}>
                                                    <Text style={styles.accHeaderMainText1}>
                                                        {('Investment' === title) && currencyFormat(returnValueOrZero(section.transaction_value))}
                                                        {('Investment' === title) && ' on '}
                                                        {CONSTANTS.CARD_TYPES[section.card_type]} {section.last_four}
                                                    </Text>
                                                    <Text style={styles.accHeaderMainText2}>
                                                        {indTransFormat(context_date)}
                                                    </Text>
                                                </View>
                                            </View>
                                            <View style={styles.accHeaderValue}>
                                                <Text style={styles.accHeaderValueText}>
                                                    {('Revenue' === title) && currencyFormat(returnValueOrZero(section.transaction_value))}
                                                    {('Investment' === title) && currencyFormat(returnValueOrZero(invest) + returnValueOrZero(section.fee))}
                                                </Text>
                                            </View>
                                        </View>
                                    )
                                }}
                                renderContent={(section, key, active) => {
                                    let invest = 0;
                                    if (section.hasOwnProperty('cashback_value')) {
                                        invest = section.cashback_value
                                    } else if (section.hasOwnProperty('refund')) {
                                        invest = section.refund
                                    }

                                    if ('Investment' === title) {
                                        return(
                                            <View key style={{ flexDirection: 'column', marginBottom: 10 }}>
                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between' }}>
                                                    <Text style={styles.accHeaderMainText2}>
                                                        Marketing Fee
                                                    </Text>
                                                    <Text style={[styles.accHeaderMainText2, { textAlign: 'right' }]}>
                                                        {currencyFormat(returnValueOrZero(section.fee))}
                                                    </Text>
                                                </View>

                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between', marginVertical: 5 }}>
                                                    <Text style={styles.accHeaderMainText2}>
                                                        Cashback Reimbursement
                                                    </Text>
                                                    <Text style={[styles.accHeaderMainText2, { textAlign: 'right' }]}>
                                                        {currencyFormat(returnValueOrZero(invest))}
                                                    </Text>
                                                </View>

                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between' }}>
                                                    <Text style={styles.accHeaderMainText1}>
                                                        Total
                                                    </Text>
                                                    <Text style={[styles.accHeaderMainText1, { textAlign: 'right' }]}>
                                                        {currencyFormat(returnValueOrZero(invest) + returnValueOrZero(section.fee))}
                                                    </Text>
                                                </View>
                                            </View>
                                        )
                                    } else {
                                        return null
                                    }
                                }}
                                />}
                        </ScrollView>
                    </View>
                    <View style={{ flex: 1, justifyContent: 'flex-end' }}>
                        <TouchableOpacity
                            activeOpacity={0.8}
                            onPress={() => this.flipCard()}>
                                <Text style={styles.flipLink}>
                                    VIEW GRAPH
                                </Text>
                        </TouchableOpacity>
                    </View>
                </Animated.View>
            </View>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/financials/index.js